module.exports = __webpack_public_path__ + "img/lighting.fffe34dc.svg";